import '@fontsource-variable/jura';
import '@fontsource/noto-sans-jp/latin-400.css';
import { KANAME_KANJI_D } from './geometry';
import './note.css';

/*
  KanameNote — сноска к слову KANAME: что оно значит (текст согласован с Максимом). Звёздочка —
  коралловая точка, та же, что после слова; «kaname» — шрифтом знака, иероглиф — коралловый (контур
  из Noto Sans JP, без загрузки японского шрифта), транскрипция с ударением и пояснение — Jura.
  Стоит на тёмной сцене: внизу входа и на странице «О Kaname». Положение задаёт тот, кто ставит.
*/

interface KanameNoteProps {
  /** Проявиться из тумана; без этого — сразу на месте. */
  animate?: boolean;
  className?: string;
}

export function KanameNote({ animate = false, className }: KanameNoteProps) {
  return (
    <p data-note="" data-note-in={animate || undefined} className={className}>
      <span aria-hidden data-note-mark="" />
      <span data-note-word="">kaname</span>{' '}
      <svg data-kanji="" viewBox="0 -880 1000 1000" role="img" aria-label="要">
        <path transform="scale(1 -1)" d={KANAME_KANJI_D} />
      </svg>{' '}
      <span data-note-reading="">
        [<span data-note-lang="">яп.</span> кан<span data-stress="">а</span>мэ]
      </span>{' '}
      — заклёпка, на которой держатся все пластины складного веера; в переносном смысле — главное, то, что
      держит целое.
    </p>
  );
}
